import React from 'react';
import {I18n} from 'react-redux-i18n';
import {Icon} from '@material-ui/core';
import DVRCardIcon from '../images/dvr-health-icon-green.svg';

const StandardIcon = props => {
  return (
    <Icon className={`dvrcard__icon dvrcard__icon-title ${props.className}`}>
      {props.children}
    </Icon>
  );
};

const StandardTitle = props => {
  return (
    <span className="dvrcard__dialogtitle">
      {I18n.t(`page.dvrHealth.dvr.${props.titleKey}`)}
    </span>
  );
};

class Status {

  getOverlayCssClass(){
    const system = localStorage.getItem('systemId');
    if(system === 'geotab'){
      return 'dvrcard__applyoverlay';
    }else{
      return '';
    }
  }

  getTitleCssClass() {
    return '';
  }

  getMobileTitleCssClass() {
    return `${this.getTitleCssClass()}-mobile`;
  }

  getIcon() {
    return '';
  }

  getTitle() {
    return '';
  }
}

class Healthy extends Status {
  getTitleCssClass() {
    return 'dvrcard__dialoghealthy';
  }

  getIcon() {
    return (
      <img
        src={DVRCardIcon}
        className="dvrcard__icon dvrcard__icon-title dvrcard__healthyicon"
      />
    );
  }

  getTitle() {
    return (
      <StandardTitle titleKey="modalTitleHealthy" />
    );
  }
}

class Uncategorized extends Status {
  getTitleCssClass() {
    return 'dvrcard__dialogunhealthy';
  }

  getIcon() {
    return (
      <StandardIcon className="dvrcard__unhealthyicon">warning</StandardIcon>
    );
  }

  getTitle() {
    return (
      <StandardTitle titleKey="modalTitleUnhealthy" />
    );
  }
}

class NoImage extends Status {
  getTitleCssClass(substatus = '') {
    if (substatus.hasdvrnotrecording) {
      return 'dvrcard__dialogunhealthy';
    } else {
      return 'dvrcard__dialogcameraissue';
    }
  }

  getIcon() {
    return (
      <StandardIcon className="dvrcard__camissueicon">videocam_off</StandardIcon>
    );
  }

  getTitle(substatus = '') {
    if (substatus.hasdvrnotrecording) {
      return (
        <StandardTitle titleKey="modalTitleUnhealthy" />
      );
    } else {
      return (
        <StandardTitle titleKey="modalTitleCameraIssue" />
      );
    }    
  }
}

class DimensionUnmatched extends Status {
  getTitleCssClass() {
    return 'dvrcard__dialogwarning';
  }

  getIcon() {
    return (
      <StandardIcon className="dvrcard__warningicon">warning</StandardIcon>
    );
  }

  getTitle() {
    return (
      <StandardTitle titleKey="modalTitleWarning" />
    );
  }
}

export default class DVRHealthStatus {
  static HEALTHY = new Healthy();
  static UNCATEGORIZED = new Uncategorized();
  static NO_IMAGE = new NoImage();
  static DIMENSION_UNMATCHED = new DimensionUnmatched();

  static forSubstatus(substatus) {
    if (substatus.uncategorized) {
      return DVRHealthStatus.UNCATEGORIZED;
    }

    if (substatus.hasnoimage || substatus.hasdvrnotrecording) {
      return DVRHealthStatus.NO_IMAGE;
    }

    if (substatus.dimensionunmatched) {
      return DVRHealthStatus.DIMENSION_UNMATCHED;
    }

    if (substatus.dimensionunvailable) {
      return DVRHealthStatus.DIMENSION_UNMATCHED;
    }

    return DVRHealthStatus.HEALTHY;
  }
}
